/**
 * UUID v4 regex pattern: 8-4-4-4-12 hexadecimal digits
 * @example
 * // e4174ea1-d229-47c2-890f-349f5f3f96de -> matches
 */
const UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi

/**
 * Маскирует чувствительные данные в пути для аналитики.
 *
 * Заменяет:
 * - UUID на `*`
 *
 * @example
 * maskSensitivePathData('/templates/edit/e4174ea1-d229-47c2-890f-349f5f3f96de')
 * // => '/templates/edit/*'
 *
 * @example
 * maskSensitivePathData('/record/c70b3b69-c77f-4d6f-9168-6774a62be832')
 * // => '/record/*'
 *
 * @example
 * maskSensitivePathData('/dashboard')
 * // => '/dashboard'
 */
export function maskSensitivePathData(path: string): string {
  return path.replace(UUID_REGEX, '*')
}
